import React, { useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CreateCountryTableList from "./CountryTableList";
import CreateCountryForm from "./CreateOrEditCountry";


const CreateCountryList = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [editCountry, setEditCountry] = useState(null);

  const handleOpenDialog = () => {
    setEditCountry(null);
    setOpenDialog(true);
  };

  const handleEdit = (country) => {
    setEditCountry(country);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditCountry(null);
  };

  return (
    <div style={{ width: "100%", padding: "20px" }}>
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2 style={{ fontFamily: "Aeonik", fontSize: "24px" }}>Country List</h2>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          sx={{
            textTransform: "none",
            background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
            fontFamily: "inherit",
          }}
          onClick={handleOpenDialog}
        >
          Create Country
        </Button>
      </div>

      {/* Country Table */}
      <CreateCountryTableList onEdit={handleEdit} />

      {/* Create/Edit Country Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md"  fullWidth>
          <CreateCountryForm
            initialData={editCountry}
            onClose={handleCloseDialog}
          />
      </Dialog>
    </div>
  );
};

export default CreateCountryList;
